import { MutationTree } from 'vuex'
import { AuthState } from './types'

export const mutations: MutationTree<AuthState> = {
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, token) {
    state.status = 'success'
    state.token = token
  },
  auth_error(state) {
    state.status = 'error'
  },
  wsConnectionActive(state, payload) {
    state.wsConnectionActive = payload
  },
  logout(state) {
    state.status = ''
    state.token = ''
    state.tokenValid = false
    state.user = {}
    state.userData = {
      id: '',
      name: '',
      lastName: '',
      userName: '',
      avatarImage: '',
      isAdmin: false,
      isMonitoring: false
    }
  },
  tokenValid(state, resp) {
    state.tokenValid = resp
  },
  setConnection(state, payload) {
    state.connection = payload
  },
  setUserData(state, payload) {
    state.userData = { ...payload }
  }
}
